import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { EditorialStep } from '../../types/editorial-step.type';

interface EditorialStepsProps {
  steps: EditorialStep[];
}

const useStyles = makeStyles((theme) => ({
  step: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    textAlign: 'center',
    padding: '1.75rem 1.25rem',
    borderRadius: 12,
    backgroundColor: '#fff',
    border: '1px solid rgba(102, 118, 29, 0.16)',
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: '1.05rem',
    lineHeight: 1.35,
    color: theme.palette.client.primary.extraDark,
  },
  // Bornée en hauteur et laissée à sa largeur naturelle : les pictogrammes de cette famille vont du
  // paysage au carré, et une largeur imposée déformerait leur rapport les uns aux autres.
  illustration: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 88,
  },
  // L'opérateur garde l'orange de l'accent : c'est ce qui préserve la lecture en équation.
  operator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '2.5rem',
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1,
    color: theme.palette.client.accent.main,
  },
}));

const EditorialSteps: React.FC<EditorialStepsProps> = ({ steps }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2} alignItems="stretch" justifyContent="center">
      {steps.map((step) => (
        // Chaque étape et son opérateur forment un couple : le fragment les garde solidaires sans
        // introduire de niveau de grille supplémentaire qui casserait l'alignement des cartes.
        <React.Fragment key={step.label}>
          {step.operator && (
            <Grid item xs={12} md="auto">
              <Typography component="span" className={classes.operator} aria-hidden="true">
                {step.operator}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12} md={3}>
            <div className={classes.step}>
              {step.illustration && (
                <img
                  className={classes.illustration}
                  src={step.illustration}
                  alt={step.illustrationAlt ?? ''}
                  loading="lazy"
                />
              )}
              {step.label}
            </div>
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default EditorialSteps;
